<script setup>
  import TideSpotSelectorLocation from '@/components/TideSpotSelectorLocation.vue';
  import Icon from '@/components/icons/Icon.vue';

  const emits = defineEmits(['click']);

  const props = defineProps({
    tideSpot: {
      type: Object,
      required: true
    },
    hasCurrentsSpot: {
      type: Boolean,
      default: false
    }
  });

  function handleButtonClick() {
    emits('click');
  }
</script>

<template>
  <button
    class="jwx-tide-spot-selector jwx-button jwx-button--primary"
    @click.prevent="handleButtonClick"
  >
    <TideSpotSelectorLocation :tideSpot="props.tideSpot" />

    <div class="jwx-tide-spot-selector__nearby-types">
      <div class="jwx-tide-spot__type-indicator" data-spot-type="tide" data-size="sm">
        <Icon name="tide-spot" class="jwx-tide-spot__type-indicator-icon" />
      </div>
      <div v-if="props.hasCurrentsSpot" class="jwx-tide-spot__type-indicator" data-spot-type="currents" data-size="sm">
        <Icon name="currents-spot" class="jwx-tide-spot__type-indicator-icon" />
      </div>
    </div>
    <div class="jwx-tide-spot-selector__action-indicator">
      <Icon name="chevron-up-down" />
    </div>
  </button>
</template>